<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="37" height="37" viewBox="0 0 37 37">
  <g id="Group_153" data-name="Group 153" transform="translate(-1426 -250)">
    <g id="Group_151" data-name="Group 151" transform="translate(-149 221.384)">
      <g id="Ellipse_80" data-name="Ellipse 80" transform="translate(1575 28.616)" fill="#69B644" stroke="#69B644" stroke-width="3">
        <circle cx="18.5" cy="18.5" r="18.5" stroke="none"/>
        <circle cx="18.5" cy="18.5" r="17" fill="none"/>
      </g>
    </g>
    <path id="ic_add_alert_24px" d="M11.458,24.937a2.4,2.4,0,0,0,4.8,0Zm10.7-5.056V12.859a8.293,8.293,0,0,0-6.383-8.072V3.918a1.918,1.918,0,0,0-3.837,0v.869a8.293,8.293,0,0,0-6.383,8.072v7.022L3,22.439v1.279H24.718V22.439Zm-3.475-4.6h-3.62V18.9H12.653v-3.62H9.033V12.859h3.62V9.239h2.413v3.62h3.62Z" transform="translate(1431 253.662)" fill="#fff"/>
  </g>
</svg>
</template>

<script>
export default {

}
</script>

<style>

</style>